export default __webpack_public_path__ + "locales/sr-Latn-RS/DataReassignmentDialog.json?hash=f9eaf244b70b38a861b2b369313aa424";